import axios from "axios";
import moment from "moment";
import { React, useState, useEffect, useContext } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../App";
import "../../components/CSS/Home/Post.css";
import "../../components/CSS/Sidebar/Left/Enroll.css";
import PostReaction from "./PostReaction";
import noImage from "../../Assets/Images/settings/no-image.png";
import {Waypoint} from "react-waypoint";


export default function SingleAuditionPost({ post }) {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const [data, setData] = useState({
    likes: post.react_number,
    updated: false,
  });

  let [shouldPlay, updatePlayState] = useState(false);

  let handleEnterViewport = function () {
    updatePlayState(true);
  };
  let handleExitViewport = function () {
    updatePlayState(false);
  };


  const handleSubmit = (id) => {
    //e.preventDefault();
    if (!data.updated) {
      setData({ likes: data.likes + 1, updated: true });
    } else {
      setData({ likes: data.likes - 1, updated: false });
    }

    axios.get(`/api/submit_react/${id}`).then((res) => {
      if (res.data.status === 200) {
      } else {
        swal("Warning", "failed", "warning");
      }
    });
  };

  return (
    <>
      <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
        <div className="card PostCardBg ">
          <div className="ViewPost">
            {/* <div className="my-3 mt-4 Enroll-a Enroll-text ">
              {post?.title}
            </div> */}
            <div className=" card  border-0 containerPost px-3 pt-3 new-audition">

              <Waypoint scrollableAncestor='window' onEnter={handleEnterViewport} onLeave={handleExitViewport}>
                <div>
                  <ReactPlayer
                    url={videoCdnUrl+post?.video}
                    controls={true}
                    playing={shouldPlay}
                    volume={1}
                    className="Live-Video-x"
                    style={{ margin: "0 auto" }}
                  />
                </div>
              </Waypoint>
              <div className="centeredPost ">
                <div className="LeftTextPost col-md-8">
                  {/* <div className=" text-light bottom-LeftPost text-start  fw-bold px-4 py-1">
                  Q&A
                </div> */}
                </div>
                <div className="LeftTextPost col-md-4">
                  <h6 className="MeetCon-left text-light">
                    {moment(
                      post?.registration_start_date
                    ).format("LL")}{" "}
                    to{" "}
                    {moment(post?.registration_end_date).format(
                      "LL"
                    )}
                  </h6>
                  <Link
                    to={`/audition/registration/${post.event_id}`}
                    className="link-starPorfile"
                  >
                    {new Date(
                      post?.registration_end_date
                    ).getTime() > new Date().getTime() ? (
                      <button className="bottom-rightPost text-dark fw-bold  px-3 mb-2">
                        <span className="pTd"> Register Now</span>
                      </button>
                    ) : (
                      <></>
                    )}
                  </Link>
                </div>
              </div>
              <div className="centeredPostV "></div>
            </div>
            <div className="row  mx-4 mt-4">
              <div className="">
                <center className="d-flex justify-content-center AudiFooter p-3">
                  <span className="carsive_font mt-2 text-warning">
                    With :{" "}
                  </span>

                  {post.audition?.assigned_judges?.map((judge, i) => (
                    <span key={i}>
                      <img
                        src={judge.user?.image?imageCdnUrl+judge.user?.image:noImage}
                        alt=""
                        className="AudiPorS ms-2"
                      />
                    </span>
                  ))}
                </center>
              </div>
            </div>

            {/*<div className="my-3 mt-4 Enroll-a Enroll-text ">*/}
            {/*  {post?.title}*/}
            {/*</div>*/}

            <div className="under-line"></div>
            <PostReaction post={post}></PostReaction>
          </div>
        </div>
      </div>
    </>
  );
}
